export default __webpack_public_path__ + "static/media/rocksteady_play_logo.5acd47b6.png";